export default "__VITE_ASSET__g$FFvgmY__"